import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Button, Form, FormGroup, InputGroup, Table } from "react-bootstrap";

import { populateListOfValues as fetchListOfValues } from "../../../webservices/generic/listOfValuesWs";
import FuseModal from "./FuseModal";
import FuseInputBox from "../inputFields/FuseInputBox";
import FuseCollapsiblePanel from "../FuseCollapsiblePanel";
import FusePanel from "../FusePanel";
import LoadingSpinner from "../LoadingSpinner";
import moment from "moment";

function FuseListOfValuesModal(props) {
  const defaultSearchSize = 100;
  const dateFormat = "dd/MM/yyyy";

  const orderByValues = [
    { key: "ASC", value: "Ascending" },
    { key: "DESC", value: "Descending" },
  ];

  const isMountedRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [listOfValues, setListOfValues] = useState({});
  const [searchSize, setSearchSize] = useState(defaultSearchSize);
  const [fromConst, setFromConst] = useState({});
  const [toConst, setToConst] = useState({});
  const [orderByConst, setOrderByConst] = useState({});

  const listOfValues_isValid = () => !_.isEmpty(listOfValues);

  const constraintsFromState = () => {
    let resColumns = [];
    if (listOfValues_isValid()) {
      listOfValues?.structure?.columns?.forEach((col, i) => {
        const { columnName } = col;
        let constraint = { columnName: columnName };
        if (fromConst.hasOwnProperty(columnName)) {
          if (toConst.hasOwnProperty(columnName))
            constraint[
              "value"
            ] = `>=${fromConst[columnName]} AND <=${toConst[columnName]}`;
          else constraint["value"] = `=${fromConst[columnName]}`;
        }
        if (orderByConst.hasOwnProperty(columnName))
          constraint["orderBy"] = orderByConst[columnName];
        resColumns.push(constraint);
      });
    }
    if (props.lovFilterKey && props.lovFilterValue) {
      resColumns.push({
        columnName: props.lovFilterKey,
        value: props.lovFilterValue,
      });
    }
    return resColumns;
  };

  const loadListOfValues = () => {
    const constraints = constraintsFromState();
    setIsLoading(true);
    fetchListOfValues(props.lovTable, searchSize, constraints)
      .then((response) => {
        if (response.data.success === true) {
          let listOfValuesData = response.data.result;
          setIsLoading(false);
          if (isMountedRef.current) setListOfValues(listOfValuesData);
        } else {
          console.log("Fetching List of Values Error");
          setIsLoading(false);
          if (isMountedRef.current) setListOfValues({});
        }
      })
      .catch((error) => {
        console.log("Fetching List of Values Error", error);
        setIsLoading(false);
        if (isMountedRef.current) setListOfValues({});
      });
  };

  const clearListOfValues = () => {
    if (isMountedRef.current) setListOfValues({});
  };

  const onShowModal = () => {
    loadListOfValues();
  };
  const onHideModal = () => {
    clearListOfValues();
  };

  //CommponentDidMount
  useEffect(() => {
    isMountedRef.current = true;
    if (props.isShowing === true) onShowModal();
    else onHideModal();
    return () => (isMountedRef.current = false);
  }, [props.isShowing]);

  // useEffect(() => {
  //   console.log(fromConst, toConst, orderByConst);
  // }, [fromConst, toConst, orderByConst]);

  const setOrderBy = (columnName, orderValue) => {
    if (orderValue == null || orderValue === "") {
      let cloneConst = _.cloneDeep(orderByConst);
      delete cloneConst[columnName];
      setOrderByConst(cloneConst);
    } else {
      setOrderByConst({
        ...orderByConst,
        [columnName]: orderValue,
      });
    }
  };

  const setFrom = (columnName, fromValue) => {
    if (fromValue == null || fromValue === "") {
      let cloneConst = _.cloneDeep(fromConst);
      delete cloneConst[columnName];
      setFromConst(cloneConst);
    } else {
      setFromConst({
        ...fromConst,
        [columnName]: fromValue,
      });
    }
  };

  const setTo = (columnName, toValue) => {
    if (toValue == null || toValue === "") {
      let cloneConst = _.cloneDeep(toConst);
      delete cloneConst[columnName];
      setToConst(cloneConst);
    } else {
      setToConst({
        ...toConst,
        [columnName]: toValue,
      });
    }
  };

  const modalTitle = () => {
    if (isLoading || !listOfValues_isValid()) return "";
    else return listOfValues.structure.header;
  };

  const renderSearchColumns = () => {
    if (!listOfValues_isValid())
      return <div>No Searchable Columns Available</div>;

    let searchableColumns = listOfValues.structure.columns.filter(
      (col) => col?.searchable === true
    );
    return (
      <Table className="table-sm">
        <thead>
          <tr>
            <th className="col-3">Column</th>
            <th className="col-3">From</th>
            <th className="col-3">To</th>
            <th className="col-2">Order by</th>
          </tr>
        </thead>
        <tbody>
          {searchableColumns.map((col, i) => {
            let cells = [];
            cells.push(
              <td key={0} className="col-3 align-middle">
                {col.column.description}
              </td>
            );
            cells.push(
              <td key={1} className="col-3 align-middle">
                <FuseInputBox
                  type="text"
                  value={fromConst?.[col.column.name] || ""}
                  editable={true}
                  onChange={(val) => {
                    setFrom(col.column.name, val);
                  }}
                />
              </td>
            );

            let toTD;
            if (col?.column?.columnType?.toLowerCase() !== "string") {
              toTD = (
                <td key={2} className="col-3 align-middle">
                  <FuseInputBox
                    type="text"
                    value={toConst?.[col.column.name] || ""}
                    editable={true}
                    onChange={(val) => {
                      setTo(col.column.name, val);
                    }}
                  />
                </td>
              );
            } else {
              toTD = <td key={2} className="col-3 align-middle"></td>;
            }
            cells.push(toTD);

            cells.push(
              <td key={3} className="col-2 align-middle">
                <FuseInputBox
                  type="dropdown"
                  value={orderByConst?.[col.column.name] || ""}
                  dropDownValues={orderByValues}
                  // dropDownDisplayValues={orderByValues}
                  dropKeyColumn="key"
                  dropValueColumn="value"
                  editable={true}
                  isClearable={false}
                  isMulti={false}
                  onChange={(val) => {
                    setOrderBy(col.column.name, val);
                  }}
                />
              </td>
            );

            return <tr key={i}>{cells}</tr>;
          })}
        </tbody>
      </Table>
    );
  };

  const renderLoading = () => {
    return <LoadingSpinner className="d-flex justify-content-center " />;
  };

  const renderSearchPanelFooter = () => {
    return (
      <Form inline={true} className="float-right">
        <FormGroup className="mr-3">
          <Form.Label srOnly={true} htmlFor="searchSize"></Form.Label>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>Search size</InputGroup.Text>
            </InputGroup.Prepend>
            <input
              type="text"
              className="form-control"
              id="searchSize"
              placeholder="Search Size"
              disabled={!listOfValues_isValid()}
              value={searchSize}
              onChange={(e) => {
                const val = e.target.value;

                //TODO: validation

                setSearchSize(parseInt(val));
              }}
            />
          </InputGroup>
        </FormGroup>
        <span></span>
        <Button
          disabled={!listOfValues_isValid()}
          onClick={() => {
            isMountedRef.current = true;
            loadListOfValues();
          }}
        >
          <i className="fa fa-search" />
          <span> Find</span>
        </Button>
      </Form>
    );
  };

  const renderSearchPanel = () => {
    let body, footer;
    if (isLoading) {
      body = renderLoading();
      footer = null;
    } else {
      body = renderSearchColumns();
      footer = renderSearchPanelFooter();
    }

    return (
      <FuseCollapsiblePanel title="Search" footer={footer}>
        {body}
      </FuseCollapsiblePanel>
    );
  };

  const renderSelectButton = (record) => {
    return (
      <Button
        variant="secondary"
        onClick={(e) => {
          props.onSubmit(record);
        }}
      >
        <i className="fa fa-check" />
      </Button>
    );
  };

  const _displayValue = (rec, col) => {
    const val = rec?.[col.column.name];
    if (
      col?.column?.columnType === "DateTime" ||
      col?.column?.columnType === "short_date"
    ) {
      let dateValue = null;
      if (val != null && val !== "" && val != 0) {
        let date = null;
        date = moment(val, dateFormat.toUpperCase()).toDate();
        if (!isNaN(date.getTime())) dateValue = date;
        else {
          date = moment(val).toDate();
          if (!isNaN(date.getTime())) dateValue = date;
        }
      }
      if (dateValue != null)
        return moment(dateValue).format(dateFormat.toUpperCase());
    }
    return val;
  };

  const renderSelectionTable = () => {
    if (!listOfValues_isValid()) {
      return <div>No Data</div>;
    } else {

			let visibleColumns = listOfValues.structure.columns.filter(
				(col) => col?.visible === true
			);

      return (
        <Table className="table-striped table-sm">
          <thead>
            <tr>
              <th className="col-1"></th>
              {visibleColumns.map((col, i) => (
                <th key={i} className="col-3">
                  {col.column.description}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {listOfValues.data.map((record, r) => {
              return (
                <tr key={r}>
                  <td className="col-1 align-middle">
                    {renderSelectButton(record)}
                  </td>
                  {visibleColumns.map((col, c) => {
                    return (
                      <td key={c} className="col-3 align-middle">
                        {_displayValue(record, col)}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      );
    }
  };

  const renderSelectionPanel = () => {
    let body;
    if (isLoading) body = renderLoading();
    else body = renderSelectionTable();

    return <FusePanel title={modalTitle()}>{body}</FusePanel>;
  };

  return (
    <FuseModal
      isShowing={props.isShowing}
      onClose={props.onClose}
      sizeString="xl"
      // title={modalTitle()}
    >
      {renderSearchPanel()}
      {renderSelectionPanel()}
    </FuseModal>
  );
}

FuseListOfValuesModal.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  lovTable: PropTypes.string.isRequired,
  lovFilterKey: PropTypes.any,
  lovFilterValue: PropTypes.any,
};

export default FuseListOfValuesModal;
